/**
 * Created by andrey on 12.02.2021.
 */

const QuestIcon = cc.Node.extend({
    ctor: function (row, options) {
        this._super();

        this.options = options || {};
        this.row = row;

        this.quest = row.data;
        this.id = row.id;

        const styles = cleverapps.styles.QuestIcon;

        const background = this.background = new cc.Scale9Sprite(bundles.questsgroupicon.frames.quest_icon_bg);
        background.setAlignment(styles.background);
        this.setContentSize2(background.width * background.scale, background.height * background.scale);
        this.setAnchorPoint(0.5, 0.5);
        this.addChild(background);

        const icon = this.icon = QuestIcon.getIconImage(this.quest);
        cleverapps.UI.fitToBox(icon, {
            width: this.width * 0.7,
            height: this.height * 0.7,
            maxScale: styles.icon.maxScale
        });
        icon.baseScale = icon.getScale();
        icon.setAnchorPoint(icon.anchorX, 0);
        this.baseScale = 1;

        if (cleverapps.config.debugMode) {
            icon.onSceneSelected = function () {
                // Needed to lookup quest id in-game for correct icon naming
                console.log(`Quest ${row.data.id}`);
            };
        }

        icon.setPosition(this.width / 2, this.height * 0.2);
        this.addChild(icon);

        const progress = this.progress = this.createProgress();
        progress.setAnchorPoint(0.5, 0.5);
        progress.setAlignment(styles.progress);
        this.addChild(progress);

        this.updateProgressText();

        if (!this.quest.unit || !this.quest.unit.code || !Families[this.quest.unit.code].oneViewForStages) {
            const magnifier = new cc.Sprite(bundles.questsgroupicon.frames.sidebar_magnifier);
            magnifier.setAlignment(styles.magnifier);
            this.addChild(magnifier);

            cleverapps.UI.applyHover(magnifier);
            cleverapps.UI.onClick(magnifier, () => {
                cleverapps.effects.fire("quests.magnifier.click");
                this.quest.find();
            }, {
                interactiveScale: false
            });
        }

        this.makeIconInteractive();
    },

    makeIconInteractive: function () {
        const questsGroupIcon = cleverapps.sideBar.findIconByClassName(QuestsGroupIcon);

        const clickHandler = function () {
            cleverapps.effects.fire("ui.button.click");

            if (this.options.clickableArea.isVisiblePoint(this)) {
                questsGroupIcon.onPressed(this);
            } else {
                questsGroupIcon.onGetView().scrollToItem(this, () => {
                    questsGroupIcon.onPressed(this);
                });
            }
        }.bind(this);

        cleverapps.UI.onClick(this, clickHandler);

        if (cleverapps.config.debugMode) {
            cleverapps.UI.onClick(this.progress, clickHandler, {
                onDoubleClick: () => {
                    this.quest.addProgress(1);
                },
                interactiveScale: false
            });
        }
    },

    createProgress: function () {
        const styles = cleverapps.styles.QuestIcon.progress;

        const background = cleverapps.UI.createScale9Sprite(bundles.questsgroupicon.frames.icon_text_bg_selected);
        background.setContentSize2(styles);

        const progressText = background.text = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.QUEST_PROGRESS_TEXT);
        progressText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        progressText.setAlignment(styles.text);
        background.addChild(progressText);

        return background;
    },

    updateRow: function (row) {
        this.row = row;

        if (this.lastProgress !== this.quest.progress) {
            if (this.quest.progress !== this.quest.goal) {
                this.highlight(2.2);
            }

            this.updateProgressText();
        }
    },

    updateProgressText: function () {
        this.lastProgress = this.quest.progress;

        this.progress.text.setString(`${this.quest.progress}/${this.quest.goal}`);
        this.progress.text.fitTo({ width: this.progress.width * 0.9, height: 0 });
    },

    highlight: function (duration) {
        if (this.highlightInProgress) {
            return;
        }

        const questsGroupIcon = cleverapps.sideBar.findIconByClassName(QuestsGroupIcon);
        const questGroupIconView = questsGroupIcon.onGetView();
        if (questGroupIconView) {
            questGroupIconView.scrollToItem(this);
        }

        const savedBaseScale = this.baseScale;
        this.baseScale *= 1.1;

        this.highlightInProgress = true;
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.ScaleTo(0.2, 0.9 * savedBaseScale),
            new cc.ScaleTo(0.2, 1.1 * savedBaseScale).easing(cc.easeOut(3)),
            new cc.CallFunc(() => {
                const iconLight = new cleverapps.Spine(bundles.questsgroupicon.jsons.sidebar_light_quests);
                iconLight.setAnchorPoint(0.5, 0.5);
                iconLight.setAlignment(this.width / 2, this.height / 2);
                iconLight.setAnimation(0, "animation", false);
                iconLight.setCompleteListenerRemove();
                this.background.addChild(iconLight);

                if (this.quest.progress !== this.quest.goal) {
                    if (questsGroupIcon && questsGroupIcon.available) {
                        const addedIcon = questsGroupIcon.onGetIconViewListener(this.quest);
                        if (addedIcon) {
                            questsGroupIcon.showInfo(addedIcon.quest, {
                                compact: this.quest.progress !== 0,
                                iconView: addedIcon
                            });
                        }
                    } else {
                        const questsIcon = cleverapps.sideBar.findIconByClassName(QuestsIcon);
                        if (questsIcon && questsIcon.available) {
                            questsIcon.showInfo(this.quest, { compact: this.quest.progress !== 0 });
                        }
                    }
                }
            }),
            new cc.DelayTime(duration || 2.2),
            new cc.ScaleTo(0.2, 0.9 * savedBaseScale),
            new cc.ScaleTo(0.2, savedBaseScale).easing(cc.easeOut(3)),
            new cc.CallFunc(() => {
                this.highlightInProgress = false;
                this.baseScale = savedBaseScale;
            })
        ));
    },

    getPreferredBundles: function () {
        return ["main"];
    }
});

QuestIcon.getIconImage = function (quest) {
    return quest.getIcon();
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    QUEST_PROGRESS_TEXT: {
        name: "default",
        size: 38,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR
    }
});

cleverapps.styles.QuestIcon = {
    background: {
        x: { align: "center" },
        y: { align: "center" },
        width: 300,
        height: 300
    },

    icon: {
        maxScale: 1.6
    },

    magnifier: {
        x: { align: "right", dx: 8 },
        y: { align: "top", dy: -4 }
    },

    checkmark: {
        x: { align: "right", dx: 10 },
        y: { align: "top", dy: 5 }
    },

    progress: {
        x: { align: "center" },
        y: { align: "bottom", dy: -28 },

        width: 160,
        height: 52,

        text: {
            x: { align: "center" },
            y: { align: "center", dy: 3 }
        }
    }
};